import React from 'react'
import {useGameStore} from '../../store/GameStoreContext.ts'
import {
    UIGameActionBoxPickCard,
    type UIGameActionBoxPickCardProps,
} from '../../common/UIGameActionBox/variants/UIGameActionBoxPickCard/UIGameActionBoxPickCard.tsx'
import {
    UIGameActionBoxPickPlayer,
    type UIGameActionBoxPickPlayerProps,
} from '../../common/UIGameActionBox/variants/UIGameActionBoxPickPlayer/UIGameActionBoxPickPlayer.tsx'
import {
    UIGameActionBoxPickDice,
    type UIGameActionBoxPickDiceProps,
} from '../../common/UIGameActionBox/variants/UIGameActionBoxPickDice/UIGameActionBoxPickDice.tsx'
import {
    UIGameActionBoxBase,
    type UIGameActionBoxBaseProps,
} from '../../common/UIGameActionBox/UIGameActionBoxBase.tsx'

export type ActionBoxData =
    | {id: number, type: 'pickCard', props: UIGameActionBoxPickCardProps}
    | {id: number, type: 'pickPlayer', props: UIGameActionBoxPickPlayerProps}
    | {id: number, type: 'pickDice', props: UIGameActionBoxPickDiceProps}
    | {id: number, type: 'base', props: UIGameActionBoxBaseProps}

export const UIGameActionBoxContainer = ({isPortrait = false}: {isPortrait?: boolean}) => {
    const actionBoxData = useGameStore((state) => state.actionBox.actionBoxData)

    if(!actionBoxData) {
        return null
    }

    const {type, props} = actionBoxData

    switch(type) {
        case 'pickCard':
            return <UIGameActionBoxPickCard key={actionBoxData.id} {...props} isPortrait={isPortrait} />
        case 'pickPlayer':
            return <UIGameActionBoxPickPlayer key={actionBoxData.id} {...props} isPortrait={isPortrait} />
        case 'pickDice':
            return <UIGameActionBoxPickDice key={actionBoxData.id} {...props} isPortrait={isPortrait} />
        case 'base':
            return <UIGameActionBoxBase key={actionBoxData.id} {...props} isPortrait={isPortrait} />
    }
}
